module.exports = __webpack_public_path__ + "static/media/photo3.ebac2ffb.jpg";